import React, { useState, useEffect } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Save } from "react-feather";
import ToastNotification from "Components/UI/ToastNotification";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import { FormProvider, useForm } from "react-hook-form";
import { format } from "date-fns";
import { yupResolver } from "@hookform/resolvers/yup";
import Error404 from "MainPages/ErrorPages/error404";
import { all_routes } from "Router/all_routes";
import { Link, useNavigate, useParams } from "react-router-dom";
import { cpfPercentageValidation } from "core/Operations/ValidationSchema/MasterValidationSchema";
import CPFPercentageForm from "Components/Form/CPFPercentageFrom";
import {
  useGetCPFPercentageByIdQuery,
  useUpdateCPFPercentageMutation,
} from "AppQuries/master/CpfPercenatge/cpf-percentage";
import LoadingSpinner from "Components/UI/LoadingSpinner";
const EditCPFPercentage = () => {
  const { code } = useParams();
  const userData = useSelector(loggedInUser);

  const {
    data: cpfPercentage,
    isLoading: isFetching,
    isError: isFetchingerror,
    error: fetchingError,
  } = useGetCPFPercentageByIdQuery(
    {
      code: code,
    },
    {
      enabled: !!code,
    }
  );
  const {
    mutate: editCPFPercentage,
    isPending,
    isError,
    error,
  } = useUpdateCPFPercentageMutation();
  const methods = useForm({
    resolver: yupResolver(cpfPercentageValidation),
  });

  const navigate = useNavigate();

  const {
    setValue,
    handleSubmit,
    formState: { errors },
  } = methods;
  const [message, setMessage] = useState("");
  const [showErrorToast, setShowErrorToast] = useState(false);
  const [showSuccessToast, setShowSuccessToast] = useState(false);

  const onSubmit = (payload) => {
    (payload.modifyUser = userData.userName),
      (payload.modifyDate = format(new Date(), "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'")),
      console.log(payload);
    editCPFPercentage(payload, {
      onSuccess: (data) => {
        console.log(data);
        if (data === true) {
          setMessage("CPF Percentage Updated Successfully.");
          setShowSuccessToast(true);
          setTimeout(() => {
            navigate(`${all_routes.master}${all_routes.cpfPercentage}`);
          }, 1000);
        } else {
          setMessage("Something went wrong.");
          setShowErrorToast(true);
        }
      },
      onError: (error) => {
        setMessage(error.message || "Something went wrong.");
        setShowErrorToast(true);
      },
    });
  };

  useEffect(() => {
    if (Array.isArray(cpfPercentage)) {
      Object.keys(cpfPercentage[0]).forEach((key) => {
        let v = cpfPercentage[0][key];
        if (key === "cpftype") {
          v = cpfPercentage[0][key].toString().trim();
        }
        setValue(key, v);
      });
    }
  }, [cpfPercentage]);
  if (isError) return <Error404 error={error} />;
  if (isFetchingerror) return <Error404 error={fetchingError} />;
  if (isFetching) return <LoadingSpinner />;
  return (
    <div>
      <div className="toast-container position-fixed top-0 end-0 p-3">
        <ToastNotification
          showSuccessToast={showSuccessToast}
          showErrorToast={showErrorToast}
          message={message}
        />
      </div>
      <div className="page-wrapper">
        <FormProvider {...methods}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="content">
              <div className="page-header">
                <div className="add-item d-flex">
                  <div className="page-title">
                    <h4>Add New CPF Percentage</h4>
                    <h6>Add your new cpf percengate details </h6>
                  </div>
                </div>
                <div className="page-btn">
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      <Tooltip id="add-new-tooltip">
                        Save CPF Percentage
                      </Tooltip>
                    }
                  >
                    <button type="submit" className="btn btn-added">
                      <Save className="me-2" />
                      Save
                    </button>
                  </OverlayTrigger>
                </div>

                <div className="page-btn">
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      <Tooltip id="add-new-tooltip">
                        Back
                      </Tooltip>
                    }
                  >
                    <Link
                      className="btn btn-secondary"
                      to={`${all_routes.master}${all_routes.cpfPercentage}`}
                    >
                      <i className="fa fa-reply me-2" />
                      Back
                    </Link>
                  </OverlayTrigger>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="card border-0">
                    <div className="card-header">
                      <h4 className="card-title">Edit CPF Percentage</h4>
                    </div>
                    <div className="card-body">
                      <CPFPercentageForm />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </FormProvider>
      </div>
    </div>
  );
};

export default EditCPFPercentage;
